module.exports = __webpack_public_path__ + "img/ta.af661449.svg";